import { Component, OnInit, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Angulartics2GoogleAnalytics } from 'angulartics2';
import { TranslateArrayService } from 'src/app/services/translateArray/translate';


@Component({

  selector: 'app-merchants',
  templateUrl: './merchants.component.html',
  styleUrls: ['./merchants.component.css']
})
export class MerchantsComponent implements OnInit {

  @Input() clientMerchants$: any;

  @ViewChild(MatPaginator) paginator: MatPaginator |any;
  @ViewChild(MatSort) sort: MatSort | any;

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['denomination', 'order'];

  loader: boolean = true;

  constructor(
    private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private TranslateArrayService: TranslateArrayService
  ) { }

  ngOnInit() {
    this.angulartics2GoogleAnalytics.pageTrack("clientHome/merchants");
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["clientMerchants$"].currentValue) {
      setTimeout(() => {
        this.dataSource.data = changes["clientMerchants$"].currentValue;
        this.dataSource.paginator = this.paginator;
       
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.TranslateArrayService.get(this.dataSource.paginator);
      });
      this.loader = false;
    }
  }

  goOrder(urlEncode: string, idWebshop: string) {
    window.open(window.location.origin + "/p/" + urlEncode + "/" + idWebshop, "_blank");
  }

}
